import { ReactComponent } from "./right-fold.svg";

const RightFoldIcon = () => <ReactComponent />;

export default RightFoldIcon;
